import { FaInstagram, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
// import { MdAutoAwesome } from "react-icons/md";

function Contact() {
  return (
    <section className="section contact" id="contact">
      <div className="contact-shell">
        <div className="contact-copy">
          <span className="contact-kicker">
            {/* <MdAutoAwesome /> */}
            Contact
          </span>

          <h2>Let’s make your idea real.</h2>

          <p>
            Send us your idea, colors, theme, or reference photo. We can help
            with custom charms, combs, photo holders, keychains, and small 3D
            printed accessories.
          </p>

          <div className="contact-highlight">
            <strong>Custom orders available</strong>
            <span>
              Tell us what you want and we’ll guide you with options, colors,
              and availability.
            </span>
          </div>
        </div>

        <div className="contact-card">
          <a
            href="https://instagram.com/charmieskastle"
            target="_blank"
            rel="noreferrer"
            className="contact-item instagram"
          >
            <div className="contact-icon">
              <FaInstagram />
            </div>

            <div className="contact-text">
              <small>Instagram</small>
              <strong>@charmieskastle</strong>
              <span>
                Best place to ask for products, updates, and custom orders.
              </span>
            </div>
          </a>

          <a href="mailto:hello@charmieskastle.com" className="contact-item email">
            <div className="contact-icon">
              <FaEnvelope />
            </div>

            <div className="contact-text">
              <small>Email</small>
              <strong>hello@charmieskastle.com</strong>
              <span>Send details, ideas, colors, or reference images.</span>
            </div>
          </a>

          <a href="tel:+17868397391" className="contact-item phone">
            <div className="contact-icon">
              <FaPhoneAlt />
            </div>

            <div className="contact-text">
              <small>Custom orders</small>
              <strong>+1 (786) 839-7391</strong>
              <span>Ask about personalized pieces and product availability.</span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;